export enum InputType {
  "password" = "password",
  "select" = "select",
  "email" = "email",
  "text" = "text",
  "tel" = "tel",
}
